import { FlatPickrDirective } from './../../plugins/flatpickr/flatpickr.directive';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, NgZone } from '@angular/core';
import { IKeyValueInterface, BookingStatus } from './../../shared/config';
import { BookingTripDetail, BookingInformation } from "../models/booking-information.model";
import { Router } from "@angular/router";
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { FreeBooking } from "../models/freebookingmodel";
import { BookingService } from './../models/booking.service';

const moment = require("moment");

@Component({
  selector: 'wego-free-booking-popup',
  template: require('../views/free-booking-popup.component.html'),
})

export class FreeBookingpopupComponent implements OnInit {

  public isLoading: boolean;
  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;
  public model: FreeBooking = new FreeBooking();
  public contractTypeGroupList: any;

 
  @ViewChild('freebookingModal') public freebookingModal: any;

  @Output('OnSuccessSave') onSuccessSave = new EventEmitter();

  @Input('BookingHashId') bookingHashId: any;
 
  constructor(private authService: AuthService
    , private router: Router
    , private translate: TranslateService, private zone: NgZone, private bookingService: BookingService) {

  }

  ngOnInit() {
    this.model=new FreeBooking();
  }

  public show(): void {
    this.errorMsg = '';
    this.errorModel = [];
    this.freebookingModal.show();
  }

  public hide(): void {
    this.model = new FreeBooking();
    this.freebookingModal.hide();
  }

  private OnSuccessSave() {
    this.hide();
    let successMsg = this.translate.instant('LblFreeBookingSuccess');
    this.onSuccessSave.emit({ SuccessMessage: successMsg })
  }

  public OnSubmit() {
      this.isLoading=true;
      this.bookingService.UpdateFreeBooking(this.model).subscribe(
        res => {
          this.isLoading = false;
          if (res.data) {
            this.OnSuccessSave();
          }
          else {

            this.errorModel = res.error;
            this.errorMsg = res.error;
          }
        },
        error => {
          this.errorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/free-booking-popup.component.ts